module.exports = __webpack_public_path__ + "img/logo-white.5aab0133.png";